module.exports = __webpack_public_path__ + "static/media/gift.2415d363.svg";